// Copyright ©️ 2026 eVolve MEP, LLC

import { formatDate, type Task } from '@evolvemep/api-ts';
import type { ColDef } from 'ag-grid-enterprise';

import { CellRenderer } from 'components/Mantine/CellRenderer';
import type { EntityState } from 'components/Mantine/StatusEditor/types';
import { UserInfoBadge } from 'components/Mantine/UserInfoBadge';

type TaskEvent = Task['time']['events'][number];

export const getEventsColDef = (taskStatuses: EntityState<'Task'>[]): ColDef<TaskEvent>[] => [
  {
    headerName: 'Member',
    field: 'userId',
    flex: 2,
    cellRenderer: CellRenderer<TaskEvent>(({ data }) => <UserInfoBadge userId={data.userId} />),
  },
  {
    headerName: 'Action',
    colId: 'action',
    flex: 1,
    valueGetter: ({ data }) => taskStatuses.find((t) => t.stateId === data?.taskStatusTypeId)?.name,
  },
  {
    headerName: 'Date',
    flex: 1,
    field: 'timesStamp',
    valueFormatter: ({ value }) => formatDate(value, 'MM/dd/yy'),
  },
  {
    headerName: 'Time',
    flex: 1,
    field: 'timesStamp',
    valueFormatter: ({ value }) => formatDate(value, 'p'),
  },
];
